"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _onEnterPressed = _interopRequireDefault(require("@devsta/on-enter-pressed")),
    _dropdownLabel = require("../styles/dropdownLabel"),
    _utils = require("../utils"),
    _Checkbox = _interopRequireDefault(require("../../Checkbox/components/Checkbox"));

require("../styles/_dropdown-label.scss");

var handleSelectOption = function handleSelectOption(a, b) {
  return function () {
    a && a(b);
  };
};

function DropdownLabel(a) {
  var b = a.data,
      c = a.data,
      d = c.prefix,
      e = c.label,
      f = c.value,
      g = c.suffix,
      h = a.upperCaseLabels,
      i = a.hideSeparators,
      j = a.fontSize,
      k = a.height,
      l = a.selectOption,
      m = a.prefixSize,
      n = a.isSelected,
      o = a.isMulti;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("dropdown-option", (0, _dropdownLabel.DROPDOWN_OPTION)({
      hideSeparators: i,
      fontSize: j,
      height: k
    })),
    onClick: handleSelectOption(l, b),
    tabIndex: 0,
    role: "button",
    onKeyPress: (0, _onEnterPressed["default"])({
      onClick: handleSelectOption(l, b)
    }),
    "data-testid": "option-".concat(f)
  }, o ? _react["default"].createElement(_Checkbox["default"], {
    checked: n,
    onChange: handleSelectOption(l, b)
  }) : null, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("dropdown-option__content", (0, _dropdownLabel.DROPDOWN_LABEL)())
  }, (0, _utils.getPrefix)({
    prefix: d,
    size: m
  }), _react["default"].createElement("span", {
    className: (0, _classnames["default"])("dropdown-option__content__label", (0, _dropdownLabel.DROPDOWN_LABEL_CONTENT)({
      fontSize: j
    }))
  }, (0, _utils.getLabel)(e, {
    upperCaseLabels: h
  }))), g ? _react["default"].createElement("div", {
    className: "dropdown-option__suffix",
    style: {
      fontSize: j
    }
  }, g) : null);
}

DropdownLabel.defaultProps = {
  suffix: null,
  upperCaseLabels: !1
};

var _default = (0, _react.memo)(DropdownLabel);

exports["default"] = _default;